export const MUNICIPAL_PROPERTY_MASTER_DATA_BOUNDS = {
    nameMaxLength: 200,
    descriptionMaxLength: 2000,
    streetMaxLength: 200,
    houseNumberMaxLength: 20,
    postalCodeMaxLength: 10,
    cityMaxLength: 200,
    minEffectiveYear: 1000,
    maxEffectiveYear: 9999,
    minCommissioningYear: 1000,
};
